import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface VideoModalProps {
  videoUrl: string;
  onClose: () => void;
}
// Convert YouTube watch URLs to embed URLs
function convertToEmbedUrl(url: string): string {
  try {
    // Handle youtube.com/watch?v=VIDEO_ID format
    const watchMatch = url.match(/[?&]v=([^&]+)/);
    if (watchMatch) {
      return `https://www.youtube.com/embed/${watchMatch[1]}`;
    }
    // Handle youtu.be/VIDEO_ID format
    const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
    if (shortMatch) {
      return `https://www.youtube.com/embed/${shortMatch[1]}`;
    }
    // If already an embed URL or other format, return as is
    return url;
  } catch (error) {
    console.error('Error converting video URL:', error);
    return url;
  }
}
export function VideoModal({
  videoUrl,
  onClose
}: VideoModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  const embedUrl = convertToEmbedUrl(videoUrl);
  return <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" onClick={onClose} data-id="element-72">
      <div className="bg-white rounded-lg w-full max-w-2xl relative" onClick={e => e.stopPropagation()} data-id="element-73">
        <button onClick={onClose} className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors" aria-label="Close video" data-id="element-74">
          <XIcon className="w-8 h-8" data-id="element-75" />
        </button>

        <div className="relative pt-[56.25%]" data-id="element-76">
          <iframe src={embedUrl} className="absolute inset-0 w-full h-full rounded-lg" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Video player" data-id="element-77" />
        </div>
      </div>
    </div>;
}